import { ParseOptions, StringifyOptions } from 'query-string'

export const LOCAL_STORAGE_KEY = '@kodix/ecom-enzo'

export const URL_STRINGIFY_OPTIONS: StringifyOptions = {
  skipEmptyString: true,
  skipNull: true,
  arrayFormat: 'comma'
}
export const URL_PARSE_OPTIONS: ParseOptions = { parseNumbers: false, arrayFormat: 'comma' }
